import React, { useMemo, useState } from 'react';

import { useDeleteSeverityMutation } from 'src/redux/services/centralApi';
import { type Severity } from 'src/interfaces/entities/severity';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Modal, Tooltip } from 'antd';
import { toast } from 'react-toastify';

export default function DeleteSeverity(
	{
		row,
	}: { row: Severity }
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deleteSeverity, deleteSeverityResult, ] = useDeleteSeverityMutation();

	const disabled = useMemo(() => {
		return row.org_id === null;
	}, [ row, ]);

	return <>
		<Tooltip
			title={
				disabled && 'Severidades padrões não podems ser deletadas.'
			}
		>
			<Button
				type="text"
				danger
				disabled={disabled}
				icon={<DeleteOutlined />}
				onClick={() => setOpen(true)}
			/>
		</Tooltip>
		<Modal
			centered
			title={'Excluir Severidade'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			okText="Excluir"
			onOk={() => {
				deleteSeverity(row.severity_id)
					.unwrap()
					.then(() => {
						toast.success('Severidade excluída com sucesso!', {
							autoClose: 1000,
						});
					})
					.catch((err) => {
						if (err?.status && err?.status === 500
							&& err?.data?.frontend_message) {
							toast.error(err?.data?.frontend_message, {
								autoClose: 1000,
							});
						}
					})
					.finally(() => {
						setOpen(false);
					});
			}}
			confirmLoading={deleteSeverityResult.isLoading}
		>
			<Flex>
				{`Tem certeza que deseja deletar a severidade: ${row.name}`}
			</Flex>
		</Modal>
	</>;
}